/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import TableStatus from './component/tableStatus'
import { Spin } from 'antd'

class ClubTableStatus extends React.Component {
  static defaultProps = {
    tableList: [],
    tableDetail: {
      data: {
        bill_list: [],
      },
    },
    billRecord: {
      data: [],
    },
    billRecordDetail: {
      list_records: [],
      list: [],
    },
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchClubTable().then((res) => {
      this.setState({ loading: false })
    })
  }

  render() {
    const { tableList, tableDetail, billRecord, billRecordDetail } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <TableStatus
            tableList={tableList}
            tbDetail={tableDetail}
            billRecord={billRecord}
            billRecordDetail={billRecordDetail}
            fetchClubTableDetail={this.props.fetchClubTableDetail}
            fetchClubSettlement={this.props.fetchClubSettlement}
            fetchBillRecordDetail={this.props.fetchBillRecordDetail}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    tableList: state.getClubTableStatus.tableList,
    tableDetail: state.getClubTableStatus.tableDetail,
    billRecord: state.getClubTableStatus.billRecord,
    billRecordDetail: state.getClubTableStatus.billRecordDetail,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubTableStatus))



// WEBPACK FOOTER //
// ./src/containers/ClubTableStatus/index.js